/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineScheduleViewModel } from '../../models/machine-schedule-view-model';

export interface GetFiltered$Params {
  workCenterId: number;
  ShowFinishedOrders?: boolean;
  ShiftFilterId?: number | null;
  CalculatePrimaryMachineLocationKpi?: boolean | null;
  CalculateSecondaryMachineLocationKpi?: boolean | null;
  PageIndex?: number | null;
  PageSize?: number | null;
}

export function getFiltered(http: HttpClient, rootUrl: string, params: GetFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineScheduleViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getFiltered.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('ShowFinishedOrders', params.ShowFinishedOrders, {});
    rb.query('ShiftFilterId', params.ShiftFilterId, {});
    rb.query('CalculatePrimaryMachineLocationKpi', params.CalculatePrimaryMachineLocationKpi, {});
    rb.query('CalculateSecondaryMachineLocationKpi', params.CalculateSecondaryMachineLocationKpi, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineScheduleViewModel>>;
    })
  );
}

getFiltered.PATH = '/api/v1/MachineSchedule/{workCenterId}/Filtered';
